import React from 'react';
import { isAdminSite, isPlatformSite } from '../utils/adminSite';

// The splash screen from public/index.html (its styles live there too), shown
// while the app checks who is signed in, so opening the app goes straight from
// the splash to the page, with no sign-in form flashing up in between. It is
// the site's Home Screen icon on the icon's own background colour, filling the
// screen. Keep in step with the script in public/index.html.
const LOGO_KEY = 'splash-logo';

const LIGHT_ON_DARK = { fg: 'rgba(255,255,255,0.8)', track: 'rgba(255,255,255,0.15)' };

// The club's logo, remembered for next time the app opens (a full address
// only: index.html shows it before the app knows where the API is)
export function rememberSplashLogo(logoUrl) {
  try {
    if (/^https:\/\//.test(logoUrl || '')) localStorage.setItem(LOGO_KEY, logoUrl);
    else localStorage.removeItem(LOGO_KEY);
  } catch { /* storage blocked */ }
}

// { logo, bg, fg, track, club }: Run The Club's sites always show their own
// icon; a club's site shows the club's logo when it has one, else the TL icon
export function splashLook() {
  if (isAdminSite()) return { logo: '/rtc-admin-touch-icon.png', bg: '#0c0f2e', ...LIGHT_ON_DARK };
  if (isPlatformSite()) return { logo: '/rtc-touch-icon.png', bg: '#0c0f2e', ...LIGHT_ON_DARK };
  let club = null;
  try { club = localStorage.getItem(LOGO_KEY); } catch { /* storage blocked */ }
  if (club) return { logo: club, bg: '#f5f5f5', fg: '#888', track: 'rgba(0,0,0,0.1)', club: true };
  return { logo: '/tl-touch-icon.png', bg: '#2e2e2e', ...LIGHT_ON_DARK };
}

export default function Splash() {
  const look = splashLook();
  return (
    <div
      className={`app-splash${look.club ? ' app-splash--club' : ''}`}
      style={{ '--splash-bg': look.bg, '--splash-fg': look.fg, '--splash-track': look.track }}
      role="status"
      aria-label="Loading"
    >
      <img className="app-splash__logo" src={look.logo} alt="" />
      <div className="app-splash__spinner" />
    </div>
  );
}
